/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { ToolsDashbord, ForwardedMapRender, MarkerPoint } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { DamsServices, IDamsList } from '../../services/api/dams/DamServices';
import { Loadin } from '../../components/shared';
import { useAuthContext } from '../../context';

export const LocationsDan = () => {
  // const iconeSVG = "<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#e8eaed'><path d='M80-240v-80q38 0 56.5-20t77.5-20q59 0 77.5 20t54.5 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20q38 0 55.5-20t76.5-20q59 0 77.5 20t56.5 20v80q-57 0-77.5-20T746-280q-36 0-54.5 20T614-240q-57 0-77.5-20T480-280q-38 0-56.5 20T346-240q-59 0-76.5-20T214-280q-38 0-56.5 20T80-240Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-440q-36 0-54.5 20T614-400q-57 0-77.5-20T480-440q-38 0-55.5 20T348-400q-59 0-78.5-20T214-440q-36 0-56.5 20T80-400Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-600q-36 0-54.5 20T614-560q-57 0-77.5-20T480-600q-38 0-55.5 20T348-560q-59 0-78.5-20T214-600q-36 0-56.5 20T80-560Z'/></svg>";
  // eslint-disable-next-line
    const iconeSVG = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300' fill='currentColor'><path fill-rule='evenodd' d='M0 276.5 L42.5 18 L44 16.5 H118 V59 l11.5-3.5 c6-2 12-2 18 1.5 l10 7.5 c3 2.5 6 5.5 10 5.5 s7-3 10-5.5 l10-7.5 c5-3.5 12-3.5 18 0 l11 8 c3 2 6 5 10 5 s7-3 10-5.5 l11-8 c5-3.5 12-3.5 18 0 l10 7.5 c3 2.5 6 5.5 10 5.5 c4.5 0 8.5-2 11.5-5 c5-5 13.5-5.5 19-1 c5 4 6 11.5 1.5 16.5 c-3 3.5-8 5.5-12.5 5.5 c-6 0-11.5-2.5-16.5-6 l-8.5-6 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9-6.5 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9.5-7 c-2-1.5-5-1.5-7 0 l-8 6 c-5.5 4-11.5 6-17.5 6 V118 c5.5 0 10.5-2 15-5.5 l8-6 c5-3.5 11-3.5 16 0 l9.5 7 c3.5 2.5 7 4 11.5 4 s8-1.5 11.5-4 l10-7 c5-3.5 11-3.5 16 0 l9 6.5 c3.5 2.5 7 4.5 11.5 4.5 s8-2 11.5-4.5 l10-7 c5-3.5 11-3.5 16 0 l8.5 6 c4 3 8.5 5.5 14 5.5 c6.5 0 12.5-3 16.5-8 c4.5-5 12-5.5 17-1 c5 4.5 5.5 12 1 17 c-4 4.5-10 7-16 7 c-6 0-12-2-17.5-6.5 l-8-6 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9-6.5 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9.5-7 c-2-1.5-5-1.5-7 0 l-8 6 c-5.5 4-11.5 6-17.5 6 V164 c5.5 0 10.5-2 15-5.5 l8-6 c5-3.5 11-3.5 16 0 l9.5 7 c3.5 2.5 7 4 11.5 4 s8-1.5 11.5-4 l10-7 c5-3.5 11-3.5 16 0 l9 6.5 c3.5 2.5 7 4.5 11.5 4.5 s8-2 11.5-4.5 l10-7 c5-3.5 11-3.5 16 0 l8.5 6 c4 3 8.5 5.5 14 5.5 c6.5 0 12.5-3 16.5-8 c4.5-5 12-5.5 17-1 c5 4.5 5.5 12 1 17 c-4 4.5-10 7-16 7 c-6 0-12-2-17.5-6.5 l-8-6 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9-6.5 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9.5-7 c-2-1.5-5-1.5-7 0 l-8 6 c-5.5 4-11.5 6-17.5 6 V210 c5.5 0 10.5-2 15-5.5 l8-6 c5-3.5 11-3.5 16 0 l9.5 7 c3.5 2.5 7 4 11.5 4 s8-1.5 11.5-4 l10-7 c5-3.5 11-3.5 16 0 l9 6.5 c3.5 2.5 7 4.5 11.5 4.5 s8-2 11.5-4.5 l10-7 c5-3.5 11-3.5 16 0 l8.5 6 c4 3 8.5 5.5 14 5.5 c6.5 0 12.5-3 16.5-8 c4.5-5 12-5.5 17-1 c5 4.5 5.5 12 1 17 c-4 4.5-10 7-16 7 c-6 0-12-2-17.5-6.5 l-8-6 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9-6.5 c-2-1.5-5-1.5-7 0 l-10 7 c-6 4.5-12 6.5-18 6.5 s-12-2.5-18-6.5 l-9.5-7 c-2-1.5-5-1.5-7 0 l-8 6 c-5.5 4-11.5 6-17.5 6 V276.5 Z M93.5 258 V41 H64 L27.5 258 Z'/></svg>";

    const [ data, setData ] = useState<IDamsList[]>();
    const [ markers, setMarkers ] = useState<MarkerPoint[]>();
    const { userData } = useAuthContext();

    // function getMarker(data: any[]): MarkerPoint[] {
    //     return data.map((marker) => {
    //         const uuid
    //         const position: [number, number] = [marker.latitude, marker.longitude];
    //         const route =  `/information_dam/${uuid}`;
    //         const showMarker = true;
    //         const title = marker.nome;
    //         // eslint-disable-next-line
    //         return { uuid, position, route, showMarker, title, icone };
    //     });
    // }

    function getMarker(data: any[]): MarkerPoint[] {
      return data.map((dam) => {
          const uuid: string = dam.uuid;
          const position: [number, number] = [dam.latitude, dam.longitude];
          const title: string = dam.nome;
          const type = 'barragem';
          const icone = iconeSVG;
          const route =  `/information_dam/${uuid}`;
          const showMarker = true;
          return { uuid, position, title, type, route, showMarker, icone };
      });
  }

    useEffect(() => {
      fetchData();
    }, []);

    const fetchData = () => {
        DamsServices.get(userData.id_empresa)
          .then((response) => {
            if(response instanceof Error){
              console.log(response.message);
            }else{
              const activeDans = response.filter(dam => dam.status === true);
              const newMarkers = getMarker(activeDans);
              setMarkers(newMarkers);
              setData(response);
            }
        });
    };

      if( data == undefined) {
        return(
            <Loadin />
        );
      }
      

    return (
       <LayoutBase 
            title='Localização das Estruturas'
            tollBar={(
                <ToolsDashbord
                />
            )}
        >
            <Box margin={0} display={'flex'} flexDirection={'column'}>
                <ForwardedMapRender
                    type='satelite'
                    show={false}
                    center={[-12.521923252021343, -51.425745155051]}
                    markerPoints={markers}
                    isLocation={true}
                    zoom={4}
                    damName=''
                />

            </Box>
       </LayoutBase>
    );
};